import { Button } from '../generic/Button';
import { getContactButtonProps } from '../../utils/navigation';
import { SignInButton } from '../generic/SignInButton';
import CloseButtonPrimary from '../../assets/icons/close-primary.svg';
import HamburgerMenuPrimary from '../../assets/icons/hamburger-menu-primary.svg';
import { useWindowSize } from '../../utils/useWindowSize';

export interface NavigationButtonsProps {
  /**
   * Indicates whether mobile menu is open
   */
  isMobileMenuOpen: boolean;
  /**
   * Mobile menu setter
   */
  setIsMobileMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  /**
   * Indicates whether button modes is
   */
  isSecondary?: boolean;
}

export const NavigationButtons = (
  {
    isMobileMenuOpen,
    setIsMobileMenuOpen,
    isSecondary,
  }: NavigationButtonsProps,
) => {
  const { width } = useWindowSize();

  return (
    <div className='nav-buttons'>
      <SignInButton className='sign-in-button' isSecondary={isSecondary} />
      <Button {...getContactButtonProps(isSecondary, width <= 1239)} className='contact-button' />
      <button
        className='mobile-menu-icon'
        id='hamburger-button'
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      >
        {!isMobileMenuOpen ? (
          <img src={HamburgerMenuPrimary} alt='Hamburger menu icon' />
        ) : (
          <img src={CloseButtonPrimary} alt='Close icon' />
        )}
      </button>
    </div>
  );
};
